import {StoragePromoCodeRepository} from '@domain/model/PromoCode/StoragePromoCodeRepository';

const SetBoxRequestPromoCode =
  (repository: StoragePromoCodeRepository) =>
  (value: string): void => {
    return repository.setPromoBoxRequest(value);
  };

export {SetBoxRequestPromoCode};
